<div class="flex justify-center w-full md:mt-11 pb-8">
    <img src="assets/icons/Icons/other-payment-options/Mobicred_logo.png" alt="mobicred logo">
</div>
<div class="w-full">
    <p class="my-6">Pay using your Mobicred account&#33;</p>
    <p class="my-4">When first registering a Mobicred account, you will undergo a simple online process to determine your credit limit. Need a Mobicred account? <a target="_" href="https://mobicred.co.za/customer/mobicred/register">Apply here</a></p>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 1:</b>
        <p class="col-span-3 md:col-span-5">Login to your Mobicred account</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 2:</b>
        <p class="col-span-3 md:col-span-5">Confirm the amount</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 3:</b>
        <p class="col-span-3 md:col-span-5">Transaction processed successfully</p>
    </div>
</div>